/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import Provider from "./src/provider"

export const wrapRootElement = Provider

// Capture Impact click id (im_ref) from the landing URL so it can be
// passed through to the Shopify checkout (see Cart.tsx).
const captureImRef = () => {
  if (typeof window === "undefined") return
  const imRef = new URLSearchParams(window.location.search).get("im_ref")
  if (imRef) {
    try {
      window.localStorage.setItem("impact_im_ref", imRef)
    } catch (e) {
      // localStorage unavailable (e.g. private browsing) — skip
    }
  }
}

export const onInitialClientRender = () => {
  captureImRef()
}

export const onRouteUpdate = () => {
  captureImRef()
}
